import type { RequestConfig } from '@customTypes/index';
import type { HousingDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type PostClubProfileHousingRequest = {
  clubId: string;
  data: HousingDto;
};

export type PostClubProfileHousingParams =
  RequestConfig<PostClubProfileHousingRequest>;

export const postClubProfileHousing = async ({
  params,
  config
}: PostClubProfileHousingParams) =>
  api.post(`/api/ClubProfile/housing/${params.clubId}`, params.data, config);
